import { Table } from "@/features/Table";
import { type A3Metadata, a3_metadata_columns } from "./columns";
import { type FilterA3MetadataSchema, FilterA3Metadata } from "./filter";
import { useLocation } from "react-router";

const client = "a3";
const table_name = "a3_metadata";

export const A3MetadataTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<A3Metadata, FilterA3MetadataSchema>
      label="A3 Metadata"
      client={client}
      table_name={table_name}
      columns={a3_metadata_columns}
      filter={<FilterA3Metadata />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
